module.exports = __webpack_public_path__ + "34a9b2d4339a5d046245d82682d795e0.MP3";